module.exports = "<div class=\"js-list layout__horizontal-layout-list\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/layout/horizontalLayout/horizontalLayout.hbs
// module id = 702
// module chunks = 0